/**
 * 发起通知
 * 
 * @export
 * @param {any} options {
 *    icon: '',通知图表
 *    body: '',通知信息
 *    title: ''通知标题
 *    time: '' 展示时间
 * }
 */
export function notification(options, callback) {
  let Notification = window.Notification || window.mozNotification || window.webkitNotification;

  if (!Notification) throw new Error('该浏览器暂不支持Notification方法');

  Notification.requestPermission(function (status) {
    // status: default 等待授权 denied 拒绝 granded 同意
    // if (status != 'granded') return

    let tag = Math.random()
    let icon = options.icon || ''
    let body = options.body || ''
    let title = options.title || ''
    let time = options.time || 1500
    let notify = new Notification(
      title,
      {
        icon,
        body,
        tag,
        lang: 'zh-CN'
      }
    );

    // notify.onclick 监听通知点击事件
    // notify.onshow 监听通知展示事件
    // notify.onclose 监听消息关闭事件
    // notify.onerror 监听消息错误事件

    notify.onclick = function () {
      window.focus();
    },
      notify.onshow = function () {
        setTimeout(function () {
          notify.close();
        }, time)
      };

    if (!callback || !(callback instanceof Function)) return
    notify.onclose = function () {
      callback()
    };

  });
}


// WEBPACK FOOTER //
// ./~/iexplore/components/notification/src/notification.js